export default [
    {
        path: '/warehouse/bin-location',
        name: 'bin-location',
        props: true,
        component: () => import('@/views/warehouse/bin-location/index.vue'),
        meta: {
            pageTitle: 'Bin Location',
            breadcrumb: [
                {
                text: 'Bin Location',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/bin-location/add',
        name: 'create-bin-location',
        component: () => import('@/views/warehouse/bin-location/create.vue'),
        meta: {
            pageTitle: 'Create Bin Location',
            breadcrumb: [
                {
                text: 'Bin Location',
                to: { name: 'bin-location' },
                },
                {
                text: 'Create Bin Location',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/bin-location/:id',
        name: 'detail-bin-location',
        props: true,
        component: () => import('@/views/warehouse/bin-location/detail.vue'),
        meta: {
            pageTitle: 'Detail Bin Location',
            breadcrumb: [
                {
                text: 'Bin Location',
                to: { name: 'bin-location' },
                },
                {
                text: 'Detail Bin Location',
                active: true,
                },
            ],
        },
    },
]